import './buttonblock.less'

import {m} from '@codeurs/front'
import {ExternalLinkIcon, FileIcon, InternalLinkIcon} from 'assets/inline-icons'
import {FunctionComponent} from 'react'
import {ImageType, LinkType} from 'types'
import {style} from 'util/style'
import {Theme} from 'views/theme'
import {Block} from './blocks'

export type ButtonBlockType = {
	btn: LinkType | ImageType
}

const styles = style('buttonblock')

function isImage(btn: LinkType | ImageType): btn is ImageType {
	return !('type' in btn)
}

export const ButtonBlock: FunctionComponent<ButtonBlockType> = ({btn}) => {
	if (!btn) return

	const to: string = isImage(btn) ? btn.src : btn.url
	const iconType: string = isImage(btn)
		? 'file'
		: btn.type === 'external' || btn.type === 'file' || btn.type === 'entry'
		? btn.type
		: null
	const buttonText = isImage(btn)
		? btn.alt || btn.src || null
		: btn.description || btn.title || btn.path || null

	return (
		<Block class={styles}>
			<Theme.Button to={to} target={'_blank'}>
				{iconType && (
					<Theme.ButtonInlineIcon>
						{getIconByType(iconType)}
					</Theme.ButtonInlineIcon>
				)}
				{buttonText && <Theme.ButtonText>{buttonText}</Theme.ButtonText>}
			</Theme.Button>
		</Block>
	)
}

export const getIconByType = (type: string) => {
	switch (type) {
		case 'external':
			return <ExternalLinkIcon className={styles('icon')} />
		case 'file':
			return <FileIcon className={styles('icon')} />
		case 'entry':
			return <InternalLinkIcon className={styles('icon')} />
		default:
			return
	}
}
